'use strict';

const defaultFormProps = {
    reValidateMode: 'onBlur',
    mode: 'onSubmit',
    criteriaMode: 'all',
};

exports.defaultFormProps = defaultFormProps;
//# sourceMappingURL=defaultFormProps.js.map
